var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{staticClass:"mb-2",attrs:{"cols":"12"}},[_c('h4',{staticClass:"mb-0"},[_vm._v(" Qualidade ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }